module.exports = lib_ui__react_slick;